// While sign ups are off in Supabase ("Allow new users to sign up"), signing in
// with Google as someone without an account is refused, and Supabase sends the
// browser back with the error in the URL's query or hash.
export const isSignupRefused = (location = window.location) => {
    const params = new URLSearchParams(location.search);
    new URLSearchParams(location.hash.replace(/^#/, '')).forEach((value, key) => params.set(key, value));
    return params.get('error_code') === 'signup_disabled'
        || /signups? not allowed/i.test(params.get('error_description') || '');
};
